import { Box, ButtonBase, Typography } from '@mui/material';
import { NavLink } from 'react-router-dom';
import { SidebarButtonsItemProps } from './sidebar-buttons-item.interface';

export function SidebarButtonsItemComponent({
  title,
  icon,
  selected = false,
  onClick,
  to,
}: SidebarButtonsItemProps) {
  return (
    <ButtonBase
      {...(to ? { component: NavLink, to } : { onClick })}
      sx={{
        width: '100%',
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        gap: 1.25,
        borderRadius: '10px',
        border: 1,
        borderColor: selected ? 'primary.main' : 'divider',
        px: 1.5,
        py: 1.25,
        bgcolor: selected ? 'action.selected' : 'background.paper',
        color: 'inherit',
        textDecoration: 'none',
        transition: 'background-color 0.2s ease, border-color 0.2s ease',
        '&:hover': {
          bgcolor: selected ? 'action.selected' : 'action.hover',
          borderColor: selected ? 'primary.main' : 'text.secondary',
        },
        '&.active': {
          borderColor: 'primary.main',
          bgcolor: 'action.selected',
          '&:hover': {
            bgcolor: 'action.selected',
            borderColor: 'primary.main',
          },
          '& .sidebar-button-icon': {
            color: 'primary.main',
          },
        },
      }}
    >
      {icon ? (
        <Box
          className="sidebar-button-icon"
          sx={{
            display: 'flex',
            color: selected ? 'primary.main' : 'text.secondary',
            '& .MuiSvgIcon-root': {
              fontSize: 22,
            },
          }}
        >
          {icon}
        </Box>
      ) : null}
      <Typography variant="body1" sx={{ textAlign: 'left' }}>
        {title}
      </Typography>
    </ButtonBase>
  );
}
